<template>
  <div ref="macbook" class="macbook relative" :style="wrapperStyle">
    <div class="container absolute" :style="containerStyle">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      width: 688,
      height: 404,
      containerWidth: 516,
      containerHeight: 320,
      containerTop: 20,
    }
  },
  computed: {
    wrapperStyle() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
      }
    },
    containerStyle() {
      return {
        width: this.containerWidth + 'px',
        height: this.containerHeight + 'px',
        top: this.containerTop + 'px',
      }
    },
  },
  mounted() {
    const pWidth = this.$refs.macbook.parentNode.offsetWidth;
    let ratio = 1;
    if(pWidth < this.width) {
      ratio = pWidth / this.width;
      this.width = pWidth;
      this.height = this.height * ratio;
      this.containerWidth = this.containerWidth * ratio;
      this.containerHeight = this.containerHeight * ratio;
      this.containerTop = this.containerTop * ratio;
    }
  }
}
</script>

<style scoped lang="scss">
.macbook {
  width: 688px;
  height: 404px;
  background: url("~@/assets/home/macbook.png") no-repeat center;
  background-size: cover;
  .container{
    width: 516px;
    height: 320px;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
